<template>
  <div class="product-add" v-loading="loading">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="商品详情" name="basic"></el-tab-pane>
      <el-tab-pane label="佣金设置" name="spec"></el-tab-pane>
      <el-tab-pane label="商品评论" name="comment"></el-tab-pane>
      <el-tab-pane label="应用技术" name="technology"></el-tab-pane>
      <el-tab-pane label="使用方法" name="usage"></el-tab-pane>
    </el-tabs>
    <div
      style="background: white;padding-left: 20px;padding-right: 20px">
      <!--      width: 1000px;margin-left: auto;margin-right: auto;-->
      <!--form表单-->
      <el-form size="small" ref="form" label-position="top" :model="form" label-width="180px" v-if="!loading">
        <!--基础信息-->
        <product-detail v-show="activeName === 'basic'"/>
        <!--        <Basic v-show="activeName === 'basic1'"></Basic>-->
        <!--规格设置-->
        <Spec v-show="activeName === 'basic1'"></Spec>
        <!--商品详情-->
        <!--        <Content v-show="activeName === 'basic1'"></Content>-->
        <!--高级设置-->
        <Buyset v-show="activeName === 'spec'"></Buyset>
      </el-form>
      <product-comment :productId="productId" v-if="activeName === 'comment'"></product-comment>
      <Technology v-if="activeName === 'technology'"></Technology>
      <Usage v-if="activeName === 'usage'"></Usage>
      <!--审核-->
      <div class="common-button-wrapper" :style="oldAudit == 0 || oldAudit == 20 ? 'height: 100px;' : 'height: 50px'">
        <el-form size="small" label-position="left" :model="form" label-width="100px">
          <Audit v-if="oldAudit == 0 || oldAudit == 20"></Audit>
        </el-form>
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary"
                   @click="changeAudit(form.model.productId, form.model.auditStatus,form.model.auditRemark)"
                   :disabled="save_loading" v-if="oldAudit == 0 || oldAudit == 20">审核
        </el-button>
        <el-button size="small" type="primary" @click="onSubmit('edit')" :disabled="save_loading">
          发布
        </el-button>
      </div>

    </div>
  </div>
</template>

<script>
import PorductApi from '@/api/product.js'
import Basic from './part/Basic.vue'
import Spec from './part/Spec.vue'
import Content from './part/Content.vue'
import Buyset from './part/Buyset.vue'
import Audit from './part/Audit.vue'
import {formatModel} from '@/utils/base.js'
import ProductComment from './../comment/index'
import Technology from './part/Technology'
import ProductDetail from '../components/ProductDetail'
import Usage from './part/Usage'

export default {
  components: {
    ProductDetail,
    Technology,
    /*基础信息*/
    Basic,
    /*规格信息*/
    Spec,
    /*商品详情*/
    Content,
    Audit,
    /*高级设置*/
    Buyset,
    ProductComment,
    Usage
  },
  data () {
    return {
      activeName: 'basic',
      /*商品ID*/
      productId: 0,
      /*判断是编辑*/
      scene: 'edit',
      /*是否正在加载*/
      loading: true,
      /*是否正在提交保存*/
      save_loading: false,
      /*form表单数据*/
      form: {
        model: {},
        /*商品分类*/
        catgory: [],
        /*运费模板*/
        delivery: [],
        /*会员等级*/
        gradeList: [],
        /*规格数据*/
        specData: null,
        /*是否锁住*/
        isSpecLocked: false,
        /*分销基础设置*/
        basicSetting: {},
      },
      /*模型数据*/
      model: {
        /*商品名称*/
        productName: '',
        productNo: '',
        productBrand: '',
        formulation: '',
        videoId: 0,
        videoFilePath: '',
        posterId: 0,
        posterFilePath: '',
        presellStartTime: '',
        presellEndTime: '',
        arrivalTime: 0,
        /*商品分类*/
        categoryId: null,
        categoryIds: [],
        /*商品图片*/
        image: [],
        isPicture: 1,
        contentImage: [],
        /*商品卖点*/
        sellingPoint: '',
        /*规格类别,默认10单规格，20多规格*/
        specType: 20,
        /*库存计算方式,默认20付款减库存，10下单减库存*/
        deductStockType: 20,
        /*检查用户等级*/
        isAloneGrade: 0,
        /*单规格*/
        sku: {
          /*产品价格*/
          productPrice: 0,
          /*产品划线价*/
          linePrice: 0,
          supplierPrice: 0,
          commissionPrice: 0,
          platRetentionPrice: 0,
          presellPrice: 0,
          /*库存数量*/
          stockNum: 0,
          /*商品重量*/
          productWeight: 0,
          /*商品编码*/
          productNo: ''
        },
        /*多规格类别*/
        specMany: {
          /*多规格类别*/
          specAttr: [],
          /*多规格表格数据*/
          specList: []
        },
        /*商品详情内容*/
        content: '',
        /*运费模板ID*/
        deliveryId: '',
        /*商品状态*/
        productStatus: 10,
        manufacturerId: 0,
        manufacturer: '',
        /*初始销量*/
        salesInitial: 0,
        /*商品排序，默认100*/
        productSort: 100,
        /*是否开启积分赠送,默认1为开启，0为关闭*/
        isPointsGift: 0,
        /*是否允许使用积分抵扣,默认1为允许，0为不允许*/
        isPointsDiscount: 0,
        /*最大积分抵扣数量*/
        maxPointsDiscount: 0,
        /*会员折扣设置,默认1为单独设置折扣,0为默认折扣*/
        isEnableGrade: 0,
        /*等级金额类型,默认10为百分比，20为固定金额*/
        aloneGradeType: 10,
        /*限购会员*/
        gradeIds: [],
        /*是否虚拟商品*/
        isVirtual: 0,
        /*是否预售*/
        isPresell: 0,
        /*限购数量*/
        limitNum: 0,
        minLimit: 1,
        deliveryType: 10,
        /*虚拟商品发货方式*/
        virtualAuto: 0,
        /*虚拟商品发货内容*/
        virtualContent: '',
        isEnableCommission: 1,
        commissionType: 10,
        commissionMoney: 0,
      },
      oldAudit: 0
    }
  },
  provide: function () {
    return {
      form: this.form
    }
  },
  created () {
    /*获取列表*/
    this.productId = parseInt(this.$route.query.productId || 0)
    this.scene = this.$route.query.scene
    this.getData()
  },
  methods: {
    /**
     * 获取基础数据
     */
    getData: function () {
      let self = this
      PorductApi.getEditData(
        {
          productId: self.productId,
          scene: self.scene
        },
        true
      )
        .then(res => {
          self.loading = false
          self.oldAudit = res.data.model.auditStatus
          /*单独产品折扣*/
          if (res.data.model.aloneGradeEquityJson != null && typeof res.data.model.aloneGradeEquityJson != 'undefined') {
            let equitys = res.data.model.aloneGradeEquityJson
            res.data.gradeList.forEach(item => {
              item.productEquity = equitys[item.gradeId]
            })
          }
          res.data.model.isVirtual = 0
          res.data.model.specType = 20
          let imageList = res.data.model.image
          if (!imageList || imageList.length < 7) {
            let len = imageList ? imageList.length : 0
            for (let i = 0; i < 7 - len; i++) {
              imageList.push({
                imageId: undefined,
                filePath: ''
              })
            }
          }
          let sellingPoint = res.data.model.sellingPoint || ''
          if (sellingPoint) {
            res.data.model.sellingPoint = sellingPoint.split(',')
          } else {
            res.data.model.sellingPoint = ''
          }
          Object.assign(self.form, res.data)
          if (res.data.specData) {
            let specList = Object.assign([], res.data.specData.specList)
            self.$set(self.form.model, 'specList', specList)
            self.$set(self.form.model, 'specMany', res.data.specData)
          } else {
            self.$set(self.form.model, 'specList', [])
            self.$set(self.form.model, 'specMany', {
              specAttr: [],
              specList: []
            })
            self.form.model.sku = res.data.model.sku[0]
          }
          if (!self.form.model.categoryIds) {
            self.form.model.categoryIds = []
          }
          // 等级id转换成数组
          if (self.form.model.gradeIds != '') {
            self.form.model.gradeIds = self.form.model.gradeIds.split(',')
            for (let i = 0; i < self.form.model.gradeIds.length; i++) {
              self.form.model.gradeIds[i] = parseInt(self.form.model.gradeIds[i])
            }
          }
        })
        .catch(error => {
          self.loading = false
          console.log(error)
        })
    },

    /*转JSON字符串*/
    convertJson (list) {
      let obj = {}
      list.forEach(item => {
        obj[item.gradeId] = item.productEquity
      })
      return JSON.stringify(obj)
    },

    /*提交*/
    onSubmit: function (submit_type) {
      let self = this
      self.$refs.form.validate(valid => {
        let params = formatModel(self.model, self.form.model)
        params.image = params.image.filter(res => {
          return res.filePath && res.imageId
        })
        let sellingPoint = params.sellingPoint
        if (sellingPoint instanceof (Array)) {
          params.sellingPoint = sellingPoint.join(',')
        }

        if (valid) {
          params.scene = self.scene
          params.productId = self.productId
          params.aloneGradeEquity = self.convertJson(self.form.gradeList)
          if (params.gradeIds.length > 0) {
            params.gradeIds = params.gradeIds.join(',')
          } else {
            params.gradeIds = ''
          }
          params.submitType = submit_type
          self.save_loading = true
          PorductApi.editProduct(params, true)
            .then(data => {
              self.save_loading = false
              self.$message({
                message: '保存成功',
                type: 'success'
              })
              self.cancelFunc()
            })
            .catch(error => {
              self.save_loading = false
            })
        } else {
          self.$message({
            message: '请检查必填项是否填写完整',
            type: 'error'
          })
        }
      })
    },

    /*修改状态*/
    changeAudit (item, value, auditRemark) {
      let self = this
      let msg = ''
      if (value == 10) {
        msg = '确认要上架该商品吗?'
      } else {
        msg = '确认要下架该商品吗?'
      }
      self
        .$confirm(msg, '提示', {
          type: 'warning'
        })
        .then(() => {
          PorductApi.changeAudit({
            productId: item,
            state: value,
            auditRemark: auditRemark
          })
            .then(data => {
              self.$message({
                message: '操作成功',
                type: 'success'
              })
              self.cancelFunc()
            })
            .catch(error => {
              self.save_loading = false
            })
        })
    },

    /*保存为草稿*/
    Draft () {
      let self = this
      self.form.model.productStatus = 30
      self.onSubmit()
    },

    /*取消*/
    cancelFunc () {
      this.$router.back(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.basic-setting-content {
}

.product-add {
  padding-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/product/product/edit.vue